import { render, staticRenderFns } from "./ComplaintMainSearch.vue?vue&type=template&id=1a9344b4&"
import script from "./ComplaintMainSearch.vue?vue&type=script&lang=js&"
export * from "./ComplaintMainSearch.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintMainSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports